import {
  Box,
  Flex,
  FormControl,
  FormErrorMessage,
  InputGroup,
  InputLeftElement,
  Stack,
  Text,
  Tooltip,
  useTheme,
} from '@chakra-ui/react';
import { Calendar, InfoCircle } from '@devd-client/devd/components';
import { SingleDatepicker } from 'chakra-dayzed-datepicker';
import { configs, propsConfig } from '../../helpers/Goals.utils';

export const DatePickerField = ({
  name,
  label,
  secondaryLabel,
  tooltipLabel,
  placeholder,
  value,
  setFieldValue,
  touched,
  errors,
}: {
  name: string;
  label: string;
  secondaryLabel?: string;
  tooltipLabel?: string;
  placeholder: string;
  value: Date | undefined;
  setFieldValue: (field: string, value: Date | undefined) => void;
  touched: any;
  errors: any;
}) => {
  const { colors } = useTheme();

  return (
    <FormControl isInvalid={Boolean(touched[name] && errors[name])}>
      <Stack>
        <Flex align={'center'} gap={1}>
          <Text fontSize="sm" fontWeight="semibold" color="text.secondary2">
            {label} *{' '}
            {secondaryLabel && (
              <Text
                as="span"
                fontSize="xs"
                fontWeight="medium"
                color="text.secondary"
              >
                {secondaryLabel}
              </Text>
            )}
          </Text>
          {tooltipLabel && (
            <Tooltip label={tooltipLabel} hasArrow placement="top">
              <Box>
                <InfoCircle height={'14px'} width={'14px'} />
              </Box>
            </Tooltip>
          )}
        </Flex>
        <InputGroup>
          <InputLeftElement pointerEvents="none">
            <Calendar
              height={'16px'}
              width={'16px'}
              color={colors.text.secondary2}
            />
          </InputLeftElement>
          <SingleDatepicker
            name={name}
            date={value}
            onDateChange={(date) => setFieldValue(name, date)}
            usePortal={true}
            propsConfigs={{
              ...propsConfig,
              inputProps: {
                ...propsConfig.inputProps,
                paddingLeft: '36px',
                placeholder,
              },
              popoverCompProps: {
                ...propsConfig.popoverCompProps,
                popoverContentProps: {
                  ...propsConfig.popoverCompProps?.popoverContentProps,
                  zIndex: 9999,
                },
              },
            }}
            configs={configs}
          />
        </InputGroup>
        <FormErrorMessage>
          {typeof errors[name] === 'string'
            ? errors[name]
            : `${label} is required`}
        </FormErrorMessage>
      </Stack>
    </FormControl>
  );
};
